export default __webpack_public_path__ + "static/media/27.fd915165.png";